import $ from '../../../../FrontendBundle/Resources/js/jquery';

/**
 * @class PropertiesPanel
 */
export default class PropertiesPanel {
    static FIELD_TOP = 'top';
    static FIELD_CENTER_TOP = 'centerTop';
    static FIELD_CUTANGLE_TOP = 'cutangleTop';
    static FIELD_LEFT = 'left';
    static FIELD_CONNECTOR_OFFSET = 'connectorOffset';
    static FIELD_CENTER_LEFT = 'centerLeft';
    static FIELD_CUTANGLE_LEFT = 'cutangleLeft';
    static FIELD_WIDTH = 'width';
    static FIELD_CONNECTOR_WIDTH = 'connectorWidth';
    static FIELD_HEIGHT = 'height';
    static FIELD_ROTATION = 'rotation';
    static FIELD_ROTATION_SELECT = 'rotationSelect';
    static FIELD_DEPTH = 'depth';
    static FIELD_DEPTHDROPDOWN = 'depthDropdown';
    static FIELD_ALIGN = 'align';
    static FIELD_VERSION = 'version';
    static FIELD_ACCESSORY = 'accessory';
    static FIELD_SIZE = 'size';
    static FIELD_FONT_SIZE = 'fontSize';
    static FIELD_COVER = 'cover';
    static FIELD_SEALING = 'sealing';
    static FIELD_DRILL_SIZE = 'drillSize';
    static FIELD_TABLELEG_SIZE = 'tablelegSize';
    static FIELD_ANGLE = 'angle';

    /**
     * Instance of field factory
     *
     * @parameter {Ofcs.Editor.PropertiesPanel.FieldFactory} fieldFactory
     *
     * @private
     */

    /**
     * Instance of selection collection
     *
     * @parameter {Ofcs.Editor.Canvas.SelectionCollection} selection
     *
     * @private
     */

    /**
     * Initializes the properties panel
     *
     * @param {Ofcs.Editor.PropertiesPanel.FieldFactory} fieldFactory Field factory
     * @param {Ofcs.Editor.Canvas.SelectionCollection} selection
     */
    constructor(fieldFactory, selection) {
        this.tooltipTemplate = $($.fn.tooltip.defaults.template).addClass('error');

        this.fields = [];
        this.fieldFactory = fieldFactory;
        this.currentItem = null;
        this.selection = selection;

        this.selection.on('selectionchange', this.onSelectionChange, this);
        this.selection.on('change', this.onItemChange, this);
    }

    /**
     * Add a field.
     *
     * @param {string} name Name of the field
     * @param {jQuery} control The contol DIV
     * @param {Ofcs.Editor} editor The global editor object
     *
     * @return {PropertiesPanel} this
     *
     * @throws Error if field name is unknown
     *
     * @chainable
     */
    addField(name, control, editor) {
        const field = this.fieldFactory.create(name, control);

        field.setEditor(editor);
        this.fields.push(field);

        return this;
    }

    onSelectionChange(selection, parameters) {
        if (this.currentItem) {
            this.currentItem.off(null, null, this);
        }

        const item = (selection.length >= 1) ? selection.first() : null;

        this.setSelection(item, selection.length, parameters);
        this.setVisibilityForSelection(item, selection.length, parameters);
        this.updateFormForSelection(item, selection.length, parameters);
        this.actionsForSelection(item, parameters);
    }

    onItemChange() {
        if (!this.currentItem) {
            return;
        }

        this.updateFormForSelection(this.currentItem, this.selectionLength);
    }

    setSelection(item, selectionLength, parameters) {
        this.currentItem = item;
        this.selectionLength = selectionLength;

        this.fields.forEach(field => field.setSelection(item, selectionLength, parameters));
    }

    setVisibilityForSelection(item, selectionLength) {
        this.fields.forEach(field => field.setVisibilityForSelection(item, selectionLength));
    }

    updateFormForSelection(item, selectionLength) {
        this.updateValues(item, selectionLength);
        this.hideErrors();
    }

    updateValues(item, selectionLength) {
        this.fields.forEach(field => field.update(item, selectionLength));
    }

    actionsForSelection(item, parameters) {
        this.fields.forEach(field => field.action(item, parameters));
    }

    hideErrors() {
        this.fields.forEach(field => field.hideError());
    }
}
